// src/utils/box.ts

export const getBoxThumbnail = async (
    fileId: string | number,
    accessToken: string
) => {
    const response = await fetch(
        `https://api.box.com/2.0/files/${fileId}/thumbnail.jpg?min_height=512&min_width=512`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch thumbnail");
    }

    // Box often returns application/octet-stream; thumbnails are always JPEG.
    const blob = await response.blob();
    const jpegBlob = blob.type?.startsWith("image/")
        ? blob
        : new Blob([blob], { type: "image/jpeg" });
    return URL.createObjectURL(jpegBlob);
};


export const getBoxFile = async (
    fileId: string | number,
    accessToken: string
) => {
    const response = await fetch(
        `https://api.box.com/2.0/files/${fileId}/content`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            redirect: "follow",
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch file");
    }

    return response.blob();
};

/**
 * Prefer a Box thumbnail; newly uploaded PNGs (extended restores) often
 * return 202 until the representation is ready — fall back to full content
 * so the image still appears after save/reload.
 */
export const getBoxPreviewUrl = async (
    fileId: string | number,
    accessToken: string,
    fileName?: string
) => {
    try {
        return await getBoxThumbnail(fileId, accessToken);
    } catch {
        const blob = await getBoxFile(fileId, accessToken);
        const mime = blob.type?.startsWith("image/")
            ? blob.type
            : /\.jpe?g$/i.test(fileName || "")
              ? "image/jpeg"
              : "image/png";
        const imageBlob = blob.type?.startsWith("image/")
            ? blob
            : new Blob([blob], { type: mime });
        return URL.createObjectURL(imageBlob);
    }
};